import { union } from "../../shared/src/codecs/types/union";
import { literal } from "../../shared/src/codecs/types/literal";

export const ListingPhotoFileMimeTypes = union([literal("image/jpeg"), literal("image/png")]);

